// extracted by mini-css-extract-plugin
export var header = "_ts-1";
export var maskBottom = "_ts-6";
export var maskMiddle = "_ts-7";
export var maskTop = "_ts-5";
export var root = "_ts-0";
export var scrollDownButton = "_ts-3";
export var scrollDownButtonHidden = "_ts-4";
export var viewport = "_ts-2";